export default {
  Index: {
    title: '汇通数科-企业级数字化解决方案服务商 | AI智能体、云服务、机器人业务',
    meta: [{
      name: 'keywords',
      content: '汇通数科,AI智能体,海量智能体,企业级数据服务,存算大模型一体机,云服务,千橙ERP,千橙收银,千橙连锁,机器人,智能巡检,零售机器人,SaaS,数字化转型'
    }, {
      name: 'description',
      content: '汇通数科是企业级数字化解决方案服务商，提供AI智能体（海量智能体、企业级数据服务、存算大模型一体机）、云服务（千橙ERP、千橙收银、千橙连锁等）、机器人（智能巡检、零售机器人）等产品，赋能企业数字化转型。'
    }]
  },
  // 数字系统/微商城
  digitalSystem: {
    title: '千橙微商城-社群电商小程序系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙微商城,微商城,社群电商,小程序商城,电商系统,汇通数科,微信商城'
    }, {
      name: 'description',
      content: '千橙微商城是社群电商小程序系统，支持微信小程序商城搭建，提供商品管理、订单处理、营销推广等功能，助力商家快速开展社群电商业务。'
    }]
  },
  // B2B2C/整合
  integration: {
    title: '千橙B2B2C供销一体化系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'B2B2C,供销一体化,多商户商城,电商系统,汇通数科,供应链系统'
    }, {
      name: 'description',
      content: '千橙B2B2C供销一体化系统，支持多商户入驻、供应链管理、订单流转等功能，打造全链路闭环交易系统。'
    }]
  },
  // O2O线上线下一体化
  onlineAndOfflineIntegration: {
    title: '千橙O2O线上线下一体化系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'O2O系统,线上线下一体化,新零售,门店管理系统,会员管理,汇通数科'
    }, {
      name: 'description',
      content: '千橙O2O线上线下一体化系统，打通线上线下数据，实现门店管理、会员管理、订单管理一体化，助力企业新零售转型。'
    }]
  },
  // 零售商城
  retailMall: {
    title: 'B2C零售商城系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'B2C商城,零售商城,网上商城,电商平台,汇通数科,商城系统'
    }, {
      name: 'description',
      content: 'B2C零售商城系统，提供完善的商品管理、订单处理、支付结算、营销推广等电商解决方案。'
    }]
  },
  // AI店长
  aiShopkeeper: {
    title: 'AI超级店长-智能门店管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI店长,智能门店,门店管理,AI运营,智能决策,汇通数科,门店数字化'
    }, {
      name: 'description',
      content: 'AI超级店长是新一代智能门店管理系统，通过AI技术赋能门店运营，提供智能决策、数据分析、会员营销等功能。'
    }]
  },
  // 在线ERP
  onlineErp: {
    title: '全渠道电商ERP系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '电商ERP,全渠道ERP,企业管理,进销存,财务管理,汇通数科'
    }, {
      name: 'description',
      content: '全渠道电商ERP系统，集成采购、库存、销售、财务等模块，实现全渠道业务统一管理。'
    }]
  },
  // SCRM产品
  scrmProduct: {
    title: 'SCRM会员管理系统-私域流量运营 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'SCRM,会员管理系统,私域流量,客户管理,会员营销,汇通数科,CRM'
    }, {
      name: 'description',
      content: 'SCRM会员管理系统，专注私域流量运营，提供会员管理、标签分组、精准营销等功能，帮助企业构建会员体系。'
    }]
  },
  // 智能客服
  intelligentService: {
    title: '智能客服系统-AI客服机器人 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '智能客服,AI客服,客服机器人,在线客服,智能客服系统,汇通数科'
    }, {
      name: 'description',
      content: '智能客服系统，基于AI技术提供7x24小时在线客服服务，智能识别客户问题并自动回复，提升客户服务效率。'
    }]
  },
  // 直播
  live: {
    title: '直播电商系统-带货直播解决方案 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '直播电商,带货直播,直播系统,直播解决方案,汇通数科,直播平台'
    }, {
      name: 'description',
      content: '直播电商系统，提供带货直播、直播带货、直播营销等解决方案，帮助商家快速开展直播电商业务。'
    }]
  },
  // 会员营销
  marketing: {
    title: '千橙会员营销系统-SCRM会员管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '会员营销,SCRM,会员管理系统,营销系统,会员运营,汇通数科'
    }, {
      name: 'description',
      content: '千橙会员营销系统，基于会员的SCRM系统，提供会员管理、会员营销、会员数据分析等功能，赋能企业会员运营。'
    }]
  },
  // 产品下载
  QcDownload: {
    title: '千橙系列产品下载-官方下载专区 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙下载,APP下载,软件试用,产品下载,汇通数科,移动端下载'
    }, {
      name: 'description',
      content: '千橙系列产品官方下载专区，提供千橙ERP、千橙收银、千橙微商城等移动端产品下载。'
    }]
  },
  // B2B渠道
  b2bChannel: {
    title: '千橙B2B分销系统-渠道订货系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'B2B分销,渠道订货,分销系统,渠道管理系统,汇通数科,B2B系统'
    }, {
      name: 'description',
      content: '千橙B2B分销系统，提供渠道订货、经销商管理、库存管理等功能，打造高效渠道分销体系。'
    }]
  },
  // 关于我们
  about: {
    title: '关于我们-汇通数科企业介绍 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '汇通数科,企业介绍,关于我们,公司简介,汇通达'
    }, {
      name: 'description',
      content: '汇通数科是数字化解决方案服务商，专注于为企业提供AI智能体、云服务、机器人等数字化产品和服务。'
    }]
  },
  // AI创作
  aiCreation: {
    title: 'AI生图-AI智能作图 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI作图,智能P图,AI生成图片,AIGC,汇通数科,AI工具'
    }, {
      name: 'description',
      content: 'AI生图是AI智能作图工具，利用人工智能技术自动生成图片，助力企业高效完成图片处理工作。'
    }]
  },
  // AI外呼
  aiCall: {
    title: 'AI外呼系统-智能电话营销 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI外呼,智能外呼,电话机器人,电销机器人,智能营销,汇通数科'
    }, {
      name: 'description',
      content: 'AI外呼系统，基于智能语音技术实现自动外呼筛选客户，助力企业提升营销效率和客户转化率。'
    }]
  },
  // 行业分析
  aiAnalysis: {
    title: 'AI行业分析-智能数据分析 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI分析,行业分析,数据分析,智能报表,数据可视化,汇通数科'
    }, {
      name: 'description',
      content: 'AI行业分析平台，提供智能数据分析、行业报告、数据可视化等服务，帮助企业洞察市场趋势。'
    }]
  },
  // 新闻
  news: {
    title: '新闻动态-汇通数科资讯中心 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '汇通数科,新闻动态,行业资讯,企业新闻,公司动态'
    }, {
      name: 'description',
      content: '汇通数科新闻动态频道，发布企业最新资讯、行业动态、产品更新等内容。'
    }]
  },
  // 微商城
  Micromall: {
    title: '微商城-社群电商小程序 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '微商城,社群电商,小程序商城,微信商城,汇通数科,电商系统'
    }, {
      name: 'description',
      content: '微商城是社群电商小程序系统，支持微信小程序搭建，提供丰富的营销插件和会员功能。'
    }]
  },
  // 连锁电商
  ChainE: {
    title: '连锁电商系统-多门店管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '连锁电商,多门店管理,连锁系统,门店管理系统,汇通数科'
    }, {
      name: 'description',
      content: '连锁电商系统，支持多门店统一管理、库存共享、会员互通，打造全渠道连锁经营体系。'
    }]
  },
  // 社群分销
  Community: {
    title: '社群分销系统-会员裂变营销 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '社群分销,分销系统,裂变营销,会员分销,汇通数科,分销商城'
    }, {
      name: 'description',
      content: '社群分销系统，通过会员裂变机制实现快速传播，提供丰富的分销激励机制。'
    }]
  },
  // B2B2C
  B2B2C: {
    title: 'B2B2C多商户商城系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'B2B2C,多商户商城,商城系统,电商平台,汇通数科'
    }, {
      name: 'description',
      content: 'B2B2C多商户商城系统，支持供应商、商家、消费者多方入驻，打造全链路交易闭环。'
    }]
  },
  // 零售电商
  Retail: {
    title: '零售电商系统-网上零售解决方案 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '零售电商,网上零售,电商系统,商城系统,汇通数科,零售系统'
    }, {
      name: 'description',
      content: '零售电商系统，提供完善的商品管理、订单处理、支付结算等电商解决方案。'
    }]
  },
  // 云采购
  CloudPurchase: {
    title: '云采购系统-企业采购管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '云采购,采购管理,企业采购,采购系统,汇通数科,供应链采购'
    }, {
      name: 'description',
      content: '云采购系统，为企业提供在线采购、供应商管理、库存管理等一体化采购解决方案。'
    }]
  },
  // 直播电商
  LiveBroadcast: {
    title: '直播电商平台-带货直播系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '直播电商,带货直播,直播系统,直播平台,汇通数科,直播带货'
    }, {
      name: 'description',
      content: '直播电商平台，提供直播带货、互动营销、商品管理等功能，助力企业快速开启直播电商模式。'
    }]
  },
  // 金融服务
  Finance: {
    title: '金融服务解决方案-供应链金融 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '金融服务,供应链金融,企业金融,汇通数科,金融系统'
    }, {
      name: 'description',
      content: '金融服务解决方案，提供供应链金融、企业融资等金融服务，赋能企业资金周转。'
    }]
  },
  // 智能收银
  Cashier: {
    title: '智能收银系统-收银软件 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '智能收银,收银系统,收银软件,POS系统,汇通数科,收银设备'
    }, {
      name: 'description',
      content: '智能收银系统，支持多种支付方式，提供商品管理、库存管理、会员管理等门店一体化解决方案。'
    }]
  },
  // 智能支付
  Payment: {
    title: '智能支付解决方案-聚合支付 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '智能支付,聚合支付,支付系统,移动支付,汇通数科,支付解决方案'
    }, {
      name: 'description',
      content: '智能支付解决方案，支持多种支付方式聚合，提供支付接口、对账管理等功能。'
    }]
  },
  // 会员CRM
  Member: {
    title: '会员CRM系统-会员管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '会员CRM,会员管理系统,会员管理,客户管理,汇通数科,CRM系统'
    }, {
      name: 'description',
      content: '会员CRM系统，提供会员管理、会员营销、数据分析等功能，帮助企业构建完善的会员体系。'
    }]
  },
  // 流量推广
  Popularize: {
    title: '流量推广解决方案-精准获客 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '流量推广,精准获客,营销推广,广告投放,汇通数科,推广系统'
    }, {
      name: 'description',
      content: '流量推广解决方案，提供精准获客、营销推广、广告投放等服务，帮助企业获取更多流量。'
    }]
  },
  // 品牌商城定制
  BrandCustom: {
    title: '品牌商城定制开发-个性化商城 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '品牌商城定制,商城开发,个性化商城,电商定制,汇通数科,商城定制'
    }, {
      name: 'description',
      content: '品牌商城定制开发服务，根据企业需求打造个性化电商平台，提供全流程定制解决方案。'
    }]
  },
  // 分销商城定制
  DistributeCustom: {
    title: '分销商城定制-多级分销系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '分销商城定制,多级分销,分销系统定制,汇通数科,分销开发'
    }, {
      name: 'description',
      content: '分销商城定制开发，支持多级分销模式，提供分销管理、佣金结算、团队管理等功能。'
    }]
  },
  // 门店管理定制
  ShopCustom: {
    title: '门店管理系统定制-门店数字化 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '门店管理定制,门店系统,门店数字化,门店管理,汇通数科,门店软件'
    }, {
      name: 'description',
      content: '门店管理系统定制，提供收银管理、库存管理、会员管理等功能，赋能门店数字化转型。'
    }]
  },
  // O2O定制
  O2OCustom: {
    title: 'O2O系统定制-线上线下一体化 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'O2O定制,线上线下一体化,新零售系统,O2O系统,汇通数科'
    }, {
      name: 'description',
      content: 'O2O系统定制，打通线上线下数据，实现全渠道一体化运营。'
    }]
  },
  // 供应链服务
  Supplychain: {
    title: '供应链服务解决方案 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '供应链服务,供应链管理,供应链系统,汇通数科,供应链解决方案'
    }, {
      name: 'description',
      content: '供应链服务解决方案，提供供应链管理、采购管理、库存管理等服务，优化企业供应链效率。'
    }]
  },
  // 代运营服务
  AgentOperation: {
    title: '代运营服务-电商代运营 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '代运营,电商代运营,店铺运营,运营服务,汇通数科,运营托管'
    }, {
      name: 'description',
      content: '代运营服务，提供店铺运营、营销策划、数据分析等电商代运营服务。'
    }]
  },
  // 渠道合作
  Cooperate: {
    title: '渠道合作-加入汇通数科 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '渠道合作,合作伙伴,加盟合作,汇通数科,渠道招募'
    }, {
      name: 'description',
      content: '汇通数科渠道合作招募，欢迎加入我们的合作伙伴体系，共同开拓市场。'
    }]
  },
  // 生态伙伴
  EcoPartner: {
    title: '生态伙伴-汇通数科合作伙伴 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '生态伙伴,合作伙伴,生态体系,汇通数科,合作伙伴计划'
    }, {
      name: 'description',
      content: '汇通数科生态伙伴计划，诚邀各类合作伙伴共建数字化生态。'
    }]
  },
  // 企业简介
  Introduce: {
    title: '企业简介-汇通数科介绍 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '企业简介,公司简介,汇通数科介绍,汇通达,企业介绍'
    }, {
      name: 'description',
      content: '汇通数科是数字化解决方案服务商，为企业提供AI智能体、云服务、机器人等数字化产品。'
    }]
  },
  // 企业动态
  Dynamic: {
    title: '企业动态-汇通数科新闻资讯 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '企业动态,新闻资讯,公司动态,汇通数科,行业新闻'
    }, {
      name: 'description',
      content: '汇通数科企业动态频道，了解公司最新资讯、行业动态、活动公告等。'
    }]
  },
  // 千橙ERP系统
  QcErpSystem: {
    title: '千橙ERP系统-门店经营管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙ERP,ERP系统,门店ERP,经营管理软件,汇通数科,进销存'
    }, {
      name: 'description',
      content: '千橙ERP系统，面向中小微实体零售门店，帮助门店提效降本增收拓客。'
    }]
  },
  // 千橙收银系统
  QcCashier: {
    title: '千橙收银系统-智能收银软件 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙收银,收银系统,智能收银,收银软件,POS系统,汇通数科'
    }, {
      name: 'description',
      content: '千橙收银系统，支持半自动/自助一体机收单，提供门店管理、会员管理等功能。'
    }]
  },
  // 千橙分销系统
  QcDistribution: {
    title: '千橙分销系统-多级分销管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙分销,分销系统,多级分销,分销管理,汇通数科,分销软件'
    }, {
      name: 'description',
      content: '千橙分销系统，提供多级分销、佣金管理、团队管理等功能，助力企业快速拓展销售渠道。'
    }]
  },
  // 千橙连锁系统
  QcChain: {
    title: '千橙连锁系统-连锁门店管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙连锁,连锁系统,连锁门店,多门店管理,汇通数科,连锁管理'
    }, {
      name: 'description',
      content: '千橙连锁系统，支持直营/联营/加盟多业态，提供门店管理、库存管理、数据分析等功能。'
    }]
  },
  // 千橙新零售系统
  QcShopkeeper: {
    title: '千橙新零售系统-门店O2O一体化 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙新零售,新零售系统,门店O2O,门店管理系统,汇通数科'
    }, {
      name: 'description',
      content: '千橙新零售系统，门店O2O一体化综合管理，支持到店/到家业务模式。'
    }]
  },
  // 千橙数字人
  QcDigit: {
    title: '千橙数字人-AI数字人直播 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙数字人,AI数字人,数字人直播,虚拟主播,汇通数科,AIGC'
    }, {
      name: 'description',
      content: '千橙数字人，AI数字人直播助手，支持智能生成主播形象，助力企业直播营销。'
    }]
  },
  // 千橙微商城
  QcShoppingMall: {
    title: '千橙微商城-社群电商小程序 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙微商城,微商城,小程序商城,社群电商,汇通数科,微信商城'
    }, {
      name: 'description',
      content: '千橙微商城系统，社群电商小程序系统，提供商品管理、订单处理、营销推广等功能。'
    }]
  },
  // 千橙会员营销
  QcMarketing: {
    title: '千橙会员营销系统-SCRM会员管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙会员营销,会员营销系统,SCRM,会员管理,汇通数科,会员运营'
    }, {
      name: 'description',
      content: '千橙会员营销系统，基于会员的SCRM系统，提供会员管理、精准营销、数据分析等功能。'
    }]
  },
  // 千橙电商S2B2C
  QcCommerce: {
    title: '千橙电商S2B2C系统-全链路交易 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙电商,S2B2C,电商系统,全链路交易,汇通数科,多商户商城'
    }, {
      name: 'description',
      content: '千橙电商S2B2C系统，提供全链路全闭环交易系统，支持多商户入驻。'
    }]
  },
  // 千橙B2B分销
  QcB2BChannel: {
    title: '千橙B2B分销系统-渠道订货 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙B2B,B2B分销,渠道订货,经销商管理,汇通数科,B2B系统'
    }, {
      name: 'description',
      content: '千橙B2B分销系统，提供渠道订货、经销商管理、库存管理等功能。'
    }]
  },
  // 千橙Qlive直播
  QcLiveBroadcast: {
    title: '千橙Qlive直播-带货直播系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙Qlive,直播电商,带货直播,直播系统,汇通数科,直播带货'
    }, {
      name: 'description',
      content: '千橙Qlive直播，提供直播带货、互动营销、商品管理等功能。'
    }]
  },
  // 千橙RPA工具箱
  QcTool: {
    title: '千橙RPA工具箱-智能自动化 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙RPA,RPA工具箱,自动化工具,机器人流程自动化,汇通数科'
    }, {
      name: 'description',
      content: '千橙RPA工具箱，提供智能自动化工具，帮助企业提升运营效率。'
    }]
  },
  // 汇团购社群营销
  QcAssociation: {
    title: '汇通数科-汇团团社群营销系统',
    meta: [{
      name: 'keywords',
      content: '汇团团,社群营销,社区团购,团购系统,汇通数科,社群分销'
    }, {
      name: 'description',
      content: '汇团团社群营销系统，社群团购分享小程序系统，支持裂变营销。'
    }]
  },
  // 信息提交
  TryModalPage: {
    title: '信息提交-咨询试用 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '信息提交,咨询试用,联系汇通数科,商务咨询'
    }, {
      name: 'description',
      content: '提交您的咨询信息，汇通数科将为您提供专业的数字化解决方案咨询服务。'
    }]
  },
  // AI业务
  ai: {
    title: 'AI智能体-海量智能体 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI智能体,海量智能体,AI产品,人工智能,汇通数科,AI应用'
    }, {
      name: 'description',
      content: '汇通数科AI智能体业务，提供海量智能体应用，涵盖AI创作、AI外呼、行业分析等场景，赋能企业数字化转型。'
    }]
  },
  // 云服务业务
  cloud: {
    title: '云服务-企业数字化云平台 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '云服务,企业云,云计算,云平台,SaaS,汇通数科,云产品'
    }, {
      name: 'description',
      content: '汇通数科云服务，提供千橙ERP、千橙收银、千橙连锁等云产品，赋能企业数字化转型。'
    }]
  },
  // 机器人业务
  robot: {
    title: '机器人-智能巡检零售机器人 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '机器人,智能巡检,零售机器人,智慧安防,汇通数科,智能机器人'
    }, {
      name: 'description',
      content: '汇通数科机器人业务，提供智能巡检机器人、零售机器人、智慧安防等解决方案。'
    }]
  },
  // AI店长
  aiShopkeeper: {
    title: 'AI超级店长-智能门店管理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI店长,智能门店,门店管理,AI运营,智能决策,汇通数科'
    }, {
      name: 'description',
      content: 'AI超级店长是新一代智能门店管理系统，通过AI技术赋能门店运营，提供智能决策，数据分析、会员营销等功能。'
    }]
  },
  // 智能客服
  intelligentService: {
    title: '智能客服系统-AI客服机器人 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '智能客服,AI客服,客服机器人,在线客服,智能客服系统,汇通数科'
    }, {
      name: 'description',
      content: '智能客服系统，基于AI技术提供7x24小时在线客服服务，智能识别客户问题并自动回复，提升客户服务效率。'
    }]
  },
  // B2B2C整合
  integration: {
    title: '千橙B2B2C供销一体化系统 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'B2B2C,供销一体化,多商户商城,电商系统,汇通数科,供应链系统'
    }, {
      name: 'description',
      content: '千橙B2B2C供销一体化系统，支持多商户入驻、供应链管理、订单流转等功能，打造全链路闭环交易系统。'
    }]
  },
  // AI创作
  aiCreation: {
    title: 'AI生图-AI智能作图 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI作图,智能P图,AI生成图片,AIGC,汇通数科,AI工具'
    }, {
      name: 'description',
      content: 'AI生图是AI智能作图工具，利用人工智能技术自动生成图片，助力企业高效完成图片处理工作。'
    }]
  },
  // AI外呼
  aiCall: {
    title: 'AI外呼系统-智能电话营销 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI外呼,智能外呼,电话机器人,电销机器人,智能营销,汇通数科'
    }, {
      name: 'description',
      content: 'AI外呼系统，基于智能语音技术实现自动外呼筛选客户，助力企业提升营销效率和客户转化率。'
    }]
  },
  // 行业分析
  aiAnalysis: {
    title: 'AI行业分析-智能数据分析 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI分析,行业分析,数据分析,智能报表,数据可视化,汇通数科'
    }, {
      name: 'description',
      content: 'AI行业分析平台，提供智能数据分析、行业报告、数据可视化等服务，帮助企业洞察市场趋势。'
    }]
  },
  // 机器人LM200
  lm200: {
    title: '智能巡检机器人LM200 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '智能巡检,巡检机器人,安防机器人,汇通数科,LM200'
    }, {
      name: 'description',
      content: '智能巡检机器人LM200，适用于园区、厂房等场景的自主巡检，提供全天候安防保障。'
    }]
  },
  // 机器人LM201
  lm201: {
    title: 'AI 健康巡检机器人LM201 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI健康巡检机器人,健康检测机器人,健康监测,智慧养老,服务机器人,汇通数科,LM201'
    }, {
      name: 'description',
      content: 'AI 健康巡检机器人LM201，为养老、护理、医院等B端场景打造，集智慧医疗、健康监护与生活服务于一体，提供自助健康检测、异常智能预警、健康档案管理、远程问诊对接等功能。'
    }]
  },
  // 机器人LM202
  lm202: {
    title: '智慧安防机器人LM202 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '智慧安防,安防机器人,巡逻机器人,汇通数科,LM202'
    }, {
      name: 'description',
      content: '智慧安防机器人LM202，提供全天候智能安防巡检，适用于社区、园区等场景。'
    }]
  },
  // 机器人LM203
  lm203: {
    title: '多功能机器人LM203 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '多功能机器人,服务机器人,汇通数科,LM203'
    }, {
      name: 'description',
      content: '多功能机器人LM203，集成多种功能于一体，适用于多种商业场景。'
    }]
  },
  // AI数据服务
  aiDataService: {
    title: 'AI数据服务-企业数据治理 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: 'AI数据服务,数据治理,数据中台,数据管理,汇通数科'
    }, {
      name: 'description',
      content: '企业级AI数据服务，提供数据治理、模型训练、快速部署等全链路数据解决方案。'
    }]
  },
  // AI服务器
  aiServer: {
    title: '存算大模型一体机-玄武钟山系列 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '存算一体机,大模型一体机,AI服务器,玄武系列,钟山系列,汇通数科'
    }, {
      name: 'description',
      content: '存算大模型一体机，玄武系列、钟山系列，软硬一体化部署，加速大模型落地应用。'
    }]
  },
  // 千橙AI合作伙伴计划
  coPlan: {
    title: '千橙AI合作伙伴计划 | 汇通数科',
    meta: [{
      name: 'keywords',
      content: '千橙AI,合作伙伴计划,AI代理商,AI智能体,渠道加盟,汇通数科'
    }, {
      name: 'description',
      content: '千橙AI合作伙伴计划，提供AI私域商城、企业福利商城、私域直播、零售AI员工等全场景智能体方案，给授权、给方法、给工具、给政策、给交付，培训、软件、消耗、政策四重收益，携手共享AI时代红利。'
    }]
  },
}
